import Button from 'app/components/Button';
import MetaphiIcon from 'app/components/icons/MetaphiIcon';
import NasLogo from 'app/components/icons/NasLogoIcon';
import Input from 'app/components/Input';
import Loading from 'app/components/Loading';
import Modal from 'app/components/Modal';
import { metaphiUrl } from 'app/constants/constant';
import React, { ReactElement } from 'react';
import style from './EmailConnectModal.module.scss';

type EmailConnectModalProps = {
  open: boolean;
  error?: ReactElement | string;
  apiError?: string;
  isLoading?: boolean;
  onSubmit?: (...args: any[]) => void;
  clearError?: (...args: any[]) => void;
  onClose?: (...args: any[]) => void;
};

const EmailConnectModal = ({
  open,
  error,
  clearError,
  apiError,
  isLoading,
  onSubmit,
  onClose,
}: EmailConnectModalProps) => {
  const className = 'c-EmailConnectModal';

  const hasError = !!(apiError || error);

  return (
    <Modal
      open={open}
      showCloseIcon={false}
      onClose={onClose}
      customContainerClass={style[`${className}__modal`]}
    >
      <div className={style[className]}>
        <div className={style[`${className}__logo`]}>
          <NasLogo />
        </div>
        <p className={style[`${className}__title`]}>Connect via Nas Wallet</p>
        <form className={style[`${className}__form`]} onSubmit={onSubmit}>
          {/*
            // @ts-ignore */}
          <Input
            type="email"
            label="Email*"
            name="email"
            error={error}
            placeholder="Enter your email"
            onChange={clearError}
            required
          />
          {hasError && (
            <p className={style[`${className}__form__error`]}>
              {error || apiError}
            </p>
          )}
          {/* // 
          @ts-ignore */}
          <Button displayType="primary" type="submit">
            Sign up
          </Button>
        </form>
        <div className={style[`${className}__footer`]}>
          Powered by
          <a href={metaphiUrl} target="_blank" rel="nooppener noreferrer">
            <MetaphiIcon />
            <span>Metaphi</span>
          </a>
        </div>
        {isLoading && (
          <div className={style[`${className}__loading`]}>
            <Loading />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default EmailConnectModal;
